import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18Myshopping1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.26 5.39a.5.5 0 0 1 .492.41l.008.09V7.1a2.503 2.503 0 0 1-2.512 2.4 2.5 2.5 0 0 1-2.426-2.254L6.81 7.08V5.89a.5.5 0 0 1 .992-.09l.008.09v1.17c.031.79.671 1.421 1.45 1.44a1.5 1.5 0 0 0 1.488-1.283l.012-.137V5.89a.5.5 0 0 1 .5-.5"
      }), /*#__PURE__*/jsx("path", {
        d: "M13.48 2.13H4.9a1.8 1.8 0 0 0-1.8 1.8l-.997 10.152C2.1 15.134 2.906 15.94 3.9 15.94h10.58a1.8 1.8 0 0 0 1.8-1.8L15.277 3.872c.003-.936-.803-1.742-1.797-1.742M4.9 3.33h8.58a.6.6 0 0 1 .6.6l1.003 10.268c-.003.273-.272.542-.603.542H3.9a.6.6 0 0 1-.6-.6l.997-10.152c.003-.39.272-.658.603-.658"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Myshopping1$1 = Svg18Myshopping1;

export { Svg18Myshopping1$1 as default };
